import moment from 'moment';
import _ from 'lodash';
import formatCurrency from 'format-currency';

class ContractMappingController {
  constructor($rootScope, $uibModal, $state, $http,toastr) {
    "ngInject";
    this.state = $state;
    this.$http = $http;
    this.$rootScope = $rootScope;

    this.contracts = [];
    this.qbContracts = [];
    this.toastr = toastr;

    this.loadContracts();
    this.loadQbContracts();
  }

  getContractName(id) {
    let x = _.find(this.qbContracts, { 'id': id});
    if(x) {
      return x.displayName;
    }
  }

  updateContractDetails(id, parameter, value) {
    let self = this;
    let obj = {};
    obj[parameter] = value;

    this.$http.patch(this.$rootScope.apiHost+"/api/admin/contracts/"+id, obj, {withCredentials: true}).then(function (success) {
      self.loadContracts();
      self.toastr.success("Successfully Paired Contract With Quickbooks!", "SUCCESS");
    }, function (failure) {
      self.toastr.error("Could Not Pair Contract With Quickbooks.", "ERROR");
    });
  }


  syncContractsWithQuickbooks() {
    let self = this;
    this.$http.get(self.$rootScope.apiHost+"/api/integrations/qb/contracts/sync", {withCredentials: true}).then(function (success) {
      self.loadContracts();
      self.loadQbContracts();
    });
  }


  loadContracts() {
    let self = this;
    this.$http.get(self.$rootScope.apiHost+"/api/admin/contracts", {withCredentials: true}).then(function (success) {
      self.contracts = success.data;
    });
  }

  loadQbContracts() {
    let self = this;
    this.$http.get(self.$rootScope.apiHost+"/api/integrations/qb/contracts", {withCredentials: true}).then(function (success) {
      self.qbContracts = success.data;
    });
  }

}

export default ContractMappingController;



// WEBPACK FOOTER //
// ./client/pages/admin/integrations/quickbooks/capabilities/contract-mapping/contract-mapping.controller.js